import React from 'react';
import PropTypes from 'prop-types';

const EndorsementOptionSection = ({
   heading,
   endorsementCode,
   selectedValue,
   onSelect,
   disabled = false,
}) => {
   const handleChange = () => {
      onSelect(!selectedValue);
   };

   return (
      <div className="row small-btm">
         <div className="col s10">
            <label className="bold black-text">
               <input
                  type="checkbox"
                  className="filled-in checkbox-blue"
                  checked={selectedValue}
                  onChange={handleChange}
                  disabled={disabled}
               />
               <span className="radio-option-label">{heading}</span>
            </label>
         </div>
      </div>
   );
};

EndorsementOptionSection.propTypes = {
   heading: PropTypes.string.isRequired,
   endorsementCode: PropTypes.string.isRequired,
   selectedValue: PropTypes.bool,
   onSelect: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
};

export default EndorsementOptionSection;
